import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import fullTime from 'flarum/common/helpers/fullTime';
export default class UnlockUserModal extends Modal {
  className() {
    return 'UnlockUserModal Modal--small';
  }
  title() {
    return app.translator.trans('ralkage-account-lockout.forum.unlock_modal.title', {
      username: this.attrs.user.displayName()
    });
  }
  content() {
    const user = this.attrs.user;
    const lockedAt = user.lockedAt();
    const lockedUntil = user.lockedUntil();
    const failedCount = user.loginFailedCount();
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "Form"
    }, lockedAt && m("p", null, app.translator.trans('ralkage-account-lockout.forum.unlock_modal.locked_since', {
      date: fullTime(lockedAt)
    })), lockedUntil ? m("p", null, app.translator.trans('ralkage-account-lockout.forum.unlock_modal.locked_until', {
      date: fullTime(lockedUntil)
    })) : m("p", null, app.translator.trans('ralkage-account-lockout.forum.unlock_modal.manually_locked')), typeof failedCount !== 'undefined' && m("p", null, app.translator.trans('ralkage-account-lockout.forum.unlock_modal.failed_attempts', {
      count: failedCount
    })), m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      loading: this.loading,
      onclick: () => this.unlock()
    }, app.translator.trans('ralkage-account-lockout.forum.unlock_modal.unlock_button')))));
  }
  unlock() {
    this.loading = true;
    this.attrs.user.save({
      isLocked: false
    }).then(() => this.hide(), this.loaded.bind(this));
  }
}
flarum.reg.add('ralkage-account-lockout', 'forum/components/UnlockUserModal', UnlockUserModal);